import React from 'react';
import { Helmet } from 'react-helmet-async';
import './NewHomePage.css';

// Components
import NewHeroSection from '../components/new-home/NewHeroSection';
import TrustStrip from '../components/new-home/TrustStrip';
import LiveOpportunities from '../components/new-home/LiveOpportunities';
import TracksSection from '../components/new-home/TracksSection';
import HowItWorksSteps from '../components/new-home/HowItWorksSteps';
import AIStudioAndSuccess from '../components/new-home/AIStudioAndSuccess';
import StatsAndWorkshops from '../components/new-home/StatsAndWorkshops';
import BottomCTA from '../components/new-home/BottomCTA';

const NewHomePage = () => {
  return (
    <div className="new-home-page">
      <Helmet>
        <title>Home - BookMyAudition (New)</title>
      </Helmet>
      
      <NewHeroSection />
      <TrustStrip />
      <LiveOpportunities />
      <TracksSection />
      <HowItWorksSteps />
      <AIStudioAndSuccess />
      <StatsAndWorkshops />
      <BottomCTA />
      
    </div>
  );
};

export default NewHomePage;
